import VideoWatchLaterSavedIcon from '@atlaskit/icon-lab/core/video-watch-later-saved';
import * as React from 'react';

export function SvgWatchLaterAdded() {
  return <VideoWatchLaterSavedIcon label="" testId="ads-refreshed-icon" />;
}
